import { Component, inject, OnInit, ViewChild, ElementRef, AfterViewInit, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { SharedIconsModule } from "@app/shared-components/shared-icons/shared-icons.module";
import { PickrightControlModule } from "@app/shared-components/form-control/form-control.module";
import { ButtonModule } from "@app/shared-components/button/button.module";
import { BrokrageService } from "@service/brokrage.service";
import { AlertService } from "@service/alert.service";
import { CommonModule } from "@angular/common";
import { NgOtpInputModule } from "ng-otp-input";
import { MatDialogRef } from "@angular/material/dialog";
import { FinvasiaComponent } from "../finvasia/finvasia.component";
import { AuthService } from "@service/auth.service";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { WindowRef } from "@service/shared.service";

@Component({
  selector: "app-kotak",
  standalone: true,
  imports: [
    CommonModule,
    SharedIconsModule,
    PickrightControlModule,
    ButtonModule,
    ReactiveFormsModule,
    NgOtpInputModule,
  ],
  templateUrl: "./kotak.component.html",
  styles: ``,
})
export class KotakComponent implements OnInit, AfterViewInit {
  @ViewChild('mobileInput', { read: ElementRef }) mobileInput!: ElementRef;
  private fb = inject(FormBuilder);
  private brokrageService = inject(BrokrageService);
  private alertService = inject(AlertService);
  private matDialogRef = inject(MatDialogRef<FinvasiaComponent>);
  private authService = inject(AuthService);
  private router = inject(Router)
  private windowRef = inject(WindowRef)
  private platformId = inject(PLATFORM_ID);

  kotakNeoModalVisible: boolean = false;
  kotakLoginForm: FormGroup;
  loading = false;

  ngOnInit() {
    this.kotakInit();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.mobileInput && this.mobileInput.nativeElement) {
        const input = this.mobileInput.nativeElement.querySelector('input');
        if (input) {
          input.focus();
        }
      }
    }, 400);
  }

  kotakInit() {
    this.kotakLoginForm = this.fb.group({
      countryCode: ["+91", [Validators.required]],
      mobileNumber: ["", [Validators.required]],
      mpin: ["", [Validators.required]],
      ucc: ["", [Validators.required]],
      totp: ["", [Validators.required]],
    });

  }

  closeDialog() {
    this.matDialogRef.close();
  }

  submitKotakLogin() {
    if (this.kotakLoginForm.invalid) return;

    this.loading = true;
    const rawData = this.kotakLoginForm.value;
    const data = {
      mobileNumber: `${rawData.countryCode}${rawData.mobileNumber}`,
      mpin: rawData.mpin,
      ucc: rawData.ucc,
      totp: rawData.totp,
      deviceToken: this.authService.getDeviceToken() || "",
      platform: isPlatformBrowser(this.platformId) ? "web" : "mobile"
    };

    this.brokrageService.kotakLogin(data).subscribe({
      next: (res) => {
        this.loading = false;
        this.alertService.success("Login Successful");

        const tokenData = {
          access_token: res?.access_token,
          refresh_token: res?.refresh_token,
          expires_in: res?.expires_in,
          scope: res?.token_type,
        };

        this.authService.saveAccessToken(tokenData);
        this.authService.setLoggedIn();

        this.authService.UpdateUserData(false).then(() => {
          this.closeDialog();
        });
      },
      error: (err) => {
        this.loading = false;
        this.alertService.error({
          title: "Login failed. Please check your credentials.",
        });
      },
    });
  }

}
